var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-pickup-filters" },
    [
      _c("pickup-filters-actions", {
        attrs: { value: _vm.value },
        on: {
          input: _vm.onChangeFilters,
          click: function($event) {
            _vm.isSidebarOpened = true
          }
        }
      }),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("vue-client-only", [
            !_vm.adaptive.isDesktop && _vm.isSidebarOpened
              ? _c(
                  "div",
                  {
                    staticClass: "m-pickup-filters__overlay",
                    on: {
                      click: function($event) {
                        if ($event.target !== $event.currentTarget) {
                          return null
                        }
                        _vm.isSidebarOpened = !_vm.isSidebarOpened
                      }
                    }
                  },
                  [
                    _c("pickup-filters-sidebar", {
                      attrs: { value: _vm.value },
                      on: {
                        close: function($event) {
                          _vm.isSidebarOpened = false
                        },
                        input: _vm.onChangeFilters
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }